import { followupIncomingChanges } from "pages/prospects/constants/activity";

export const newProspectIncomingChanges = {
  is_prospect: true,
  ...followupIncomingChanges,
};
